import React from 'react';
/**
 * React Component
 *
 * The AsperaContentSwitcher provides the content switcher (secondary tabs) for UI pages
 *
 * @example
 * ```javascript
 * <AsperaContentSwitcher selectedIndex={1} />
 * ```
 */
export class AsperaContentSwitcher extends React.Component {
    render() {
        const { className, items, selectedIndex } = this.props;
        return (React.createElement("div", { className: `aspera-content-switcher ${className ? className : ''}` },
            React.createElement("div", { "data-auto": "content-switcher-wrapper", className: "cds--content-switcher" }, items.map((item, index) => {
                return React.createElement("button", { className: `aspera-content-switcher--item cds--content-switcher-btn ${index === selectedIndex ? 'cds--content-switcher--selected' : ''}`, key: index, type: "button", tabIndex: item.tabIndex || 0, "data-auto": `content-switcher-item--${item.name}`, onClick: () => {
                        if (typeof item.onClick === 'function')
                            item.onClick(item.name);
                    }, onKeyDown: () => { } },
                    React.createElement("span", { className: "cds--content-switcher__label", title: item.text }, item.text));
            }))));
    }
}
